module.exports = __webpack_public_path__ + "img/5.cleaned_mirro.d2a906fd.svg";